export default __webpack_public_path__ + "static/media/upload.d9ee00b5.svg";